import { useToast } from '@chakra-ui/react';
import { type ReactElement, useState } from 'react';

import Table from '../data-enrichment/Table';
import { getColumnValues } from '../data-enrichment/utils/getColumnValues';
import { useFileUploadStore } from './file-upload-context';
import { validateHeaders } from './validate-headers';

const HeaderSelectionStep = ({
  ContainerElement,
}: {
  ContainerElement: ({
    onSubmit,
    children,
  }: {
    onSubmit: () => void;
    children: ReactElement;
  }) => ReactElement;
}) => {
  const mappedWorkbook = useFileUploadStore(
    (state) => state.mappedWorkbook ?? []
  );
  const setFileData = useFileUploadStore((state) => state.setData);
  const goToNext = useFileUploadStore((state) => state.goToNext);
  const toast = useToast();
  const [rowSelection, setRowSelection] = useState<{ [key: number]: boolean }>({
    0: true,
  });
  const handleOnSubmit = () => {
    const headerIndex = Object.keys(rowSelection)[0];
    const headers = mappedWorkbook[Number(headerIndex)];

    if (!headers) {
      toast({
        status: 'error',
        variant: 'left-accent',
        position: 'top-right',
        title: 'Invalid header row',
        description: 'Unable to read the selected header row.',
        isClosable: true,
        duration: 8000,
      });
      return;
    }

    const validation = validateHeaders(headers);
    if (!validation.valid) {
      validation.errors.forEach((error) => {
        toast({
          status: 'error',
          variant: 'left-accent',
          position: 'top-right',
          title: 'Invalid columns',
          description: error,
          isClosable: true,
          duration: 8000,
        });
      });
      return;
    }

    const combinedData = headers.map((header: string, index: number) => {
      const sampleData = getColumnValues({
        mappedWorkbook,
        headerIndex,
        index,
      });
      return { header, sampleData };
    });

    setFileData((prevData) => ({
      ...prevData,
      headers,
      headerIndex,
      combinedData,
    }));
    goToNext();
  };
  return ContainerElement({
    onSubmit: handleOnSubmit,
    children: (
      <Table rowSelection={rowSelection} setRowSelection={setRowSelection} />
    ),
  });
};

export default HeaderSelectionStep;
